export interface VtkPaginatedResponse<T> {
  count: number;
  limit: number;
  offset: number;
  results: T[];
}

export interface VtkJob {
  id: string;
  organization_urn: string | null;
  user: string | null;
  status: number;
  status_text: string;
  priority: number;
  region: string;
  execution_time: number;
  bytes_in: number;
  bytes_out: number;
  notify: string | null;
  job_bundle_name: string | null;
  role_arn: string | null;
  created: string;
  modified: string;
  tags: string[];
}

export interface VtkJobDetail extends VtkJob {
  tasks: VtkTask[];
}

export interface VtkTask {
  id: number;
  tool: string;
  version: string;
  status: number;
  status_text: string;
  parameters: Record<string, unknown>;
}

export interface VtkLogEntry {
  timestamp: number;
  message: string;
}

export interface VtkJobMetrics {
  id: string;
  cus: number;
  video_minutes_in: number;
  video_minutes_out: number;
  gb_in: number;
  gb_out: number;
  tasks: VtkTaskMetrics[];
}

export interface VtkTaskMetrics {
  task_id: number;
  tool: string;
  cus: number;
  video_minutes_in: number;
  video_minutes_out: number;
  gb_in: number;
  gb_out: number;
}

export const VTK_STATUS_LABELS: Record<number, string> = {
  0: 'Submitted',
  1: 'In progress',
  2: 'Completed',
  3: 'Failed',
  4: 'Aborted',
  5: 'Waiting',
  6: 'Terminated',
};

export const VTK_STATUS_COLORS: Record<number, string> = {
  0: 'cl-color-clay',
  1: 'cl-color-sky',
  2: 'cl-color-petrol',
  3: 'cl-color-berry',
  4: 'cl-color-ash',
  5: 'cl-color-clay',
  6: 'cl-color-ash',
};
